export default {
  count: 'Count',
  level: 'Level',
  name: 'Name',
  description: 'Description',
};
